// @ts-nocheck
import RootStore from "./RootStore";
import { ExtTaskData } from "../../cuba/entities/base/tsadv_ExtTaskData";
import { action, observable } from "mobx";
import { calcTotalResult, calcTotalWeight } from "../widgets/kpi/lib/calc-functions";
import { AssignedGoal } from "../../cuba/entities/base/tsadv$AssignedGoal";
import { getCubaREST } from "@cuba-platform/react";
import { GOAL_TYPE_EFFECTIVE } from "app/features/kpi/model/types";


type PerformanceGoals = {
  id: string;
  performance: number;
  type: GOAL_TYPE_EFFECTIVE;
}

type CalcPerformanceArgs = {
  id: string;
  assessment: number;
  weight: number;
  type: GOAL_TYPE_EFFECTIVE;
};

export default class {

  rootStore: RootStore;

  @observable
  tasks: ExtTaskData[] | undefined;

  @observable
  assignedGoals: AssignedGoal[] = [];

  @observable
  totalResult = 0;

  @observable
  totalWeight = 0;

  @observable
  performancePlanStage: string;

  @observable
  isLoading = false;

  @observable
  performanceMap: Map<string, PerformanceGoals> = new Map();

  @observable
  totalPerformance = 0;

  @observable
  isLoadingForm = false;

  @action
  setLoadingForm = (value: boolean) => {
    this.isLoadingForm = value;
  };

  @action
  setPerformanceObj = (newObj: PerformanceGoals) => {
    this.performanceMap.set(newObj.id, newObj);
  };

  @action
  clearPerformance = () => {
    this.performanceMap.clear();
    this.totalPerformance = 0;
  };


  @action
  setTotalPerformance = () => {
    let positiveSum = 0;
    let negativeSum = 0;


    this.performanceMap.forEach(perf => {
      if (perf.type === GOAL_TYPE_EFFECTIVE.EFFECTIVE) {
        positiveSum += perf.performance || 0;
      } else if (perf.type === GOAL_TYPE_EFFECTIVE.DEPREMATIZATION) {
        negativeSum += perf.performance || 0;
      }
    });

    this.totalPerformance = positiveSum - negativeSum;
  };


  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  setPerformancePlanStage = (stage: string) => {
    this.performancePlanStage = stage;
  };

  @action
  recalcTotalResult = (
    data: AssignedGoal[], isUserManager: boolean,
  ) => {
    this.totalResult = Math.round(calcTotalResult(data, this.performancePlanStage, isUserManager));
  };

  @action
  setIsLoading = (value: boolean) => {
    this.isLoading = value;
  };

  @action
  setTotalResult = (value: number, after?: any) => {
    this.totalResult = Math.round(value);
    if (after) after();
  };

  @action
  setTotalWeight = (value: number, after?: any) => {
    this.totalWeight = Math.round(value * 10) / 10;
    if (after) after();
  };
  @action
  recalcTotalWeight = (
    data: AssignedGoal[],
  ) => {
    this.totalWeight = calcTotalWeight(data);
  };


  @action
  setAssignedGoals = (assignedGoals: AssignedGoal[]) => {
    this.assignedGoals = assignedGoals;
  };

  @action
  changeAssignedGoal = (updatedGoal: AssignedGoal): AssignedGoal | undefined => {
    let changedGoal: AssignedGoal | undefined;

    this.assignedGoals = this.assignedGoals.map(goal => {
      if (goal.id === updatedGoal.id) {
        changedGoal = { ...goal, ...updatedGoal };
        return changedGoal;
      }
      return goal;
    });

    this.recalcTotalResult(this.assignedGoals, true);

    return changedGoal;
  };

  @action
  assignedGoalListUpdate = async () => {
    try {
      const results = await Promise.all(
        this.assignedGoals?.map(item =>
          getCubaREST()!.commitEntity(AssignedGoal.NAME, item),
        ),
      );
      return results;
    } catch (e) {
      console.error("Ошибка при сохранении целей:", e);
      throw e;
    }
  };


  clearTasks = () => {
    this.tasks = undefined;
  };

  calcPerformance = ({ id, assessment, weight, type }: CalcPerformanceArgs): PerformanceGoals => {
    const performance = type === GOAL_TYPE_EFFECTIVE.EFFECTIVE
      ? Math.round((weight * assessment) / 100)
      : assessment;
    return {
      id,
      performance,
      type,
    };
  };

  recalcPerformance = (record: AssignedGoal, value?: number | string) => {
    const weight = record.weight || 0;
    const id = record.id;
    const assessmentCurrent = value || undefined;

    const assessmentBase = record?.managerAssessment || record?.assessment;

    const assessment =
      assessmentCurrent ||
      assessmentBase;

    const type = record.assignedGoalType || GOAL_TYPE_EFFECTIVE.EFFECTIVE;

    const performanceObj = this.calcPerformance({ id, assessment, weight, type });
    this.setPerformanceObj(performanceObj);

    this.setTotalPerformance();
  };


  @action
  setTasks = (tasks: ExtTaskData[] | undefined) => {
    this.tasks = tasks;
  };
}
